<div mat-dialog-content>
  <div>{{ 'profile.request_maintenance.error'| transloco }}</div>
</div>
<button mat-flat-button color="primary" (click)="dialogRef.close(true)">
  {{ 'common.confirm' | transloco }}
</button>
